import { generatePath } from 'react-router-dom';

import {
  FILES_BASES,
  ROUTES,
  SPARE_PART_ROUTES,
  TABS_BILLING,
  TABS_FILE,
  TABS_FILE_HISTORIC,
  TABS_HISTORIES,
  TABS_HOME_INTERVENTION,
  TABS_INTERVENTION_REPORT,
  TABS_SPARE_PARTS,
  TabsTransport,
} from '../constants/routing';

export function buildFilesUrl({
  fileId,
  fileTabId,
}: {
  fileId?: string;
  fileTabId?: TABS_FILE;
} = {}): string {
  if (!fileId) {
    return generatePath(ROUTES.FILES_NEW_UI);
  }

  return generatePath(ROUTES.FILE_DETAILS, {
    fileId,
    fileTabId,
  });
}

export function buildHistoricFilesUrl({
  fileId,
  fileTabId,
}: {
  fileId?: string;
  fileTabId?: TABS_FILE_HISTORIC;
} = {}): string {
  return generatePath(ROUTES.ALL_FILES, {
    fileId,
    fileTabId,
    fileBase: FILES_BASES.FILES_HISTORIC,
  });
}

export function buildNewTodosUrl(): string {
  return generatePath(ROUTES.TODOS_NEW_UI);
}

export function buildTodosUrl({
  fileId,
  fileTabId,
}: {
  fileId?: string;
  fileTabId?: TABS_FILE;
} = {}): string {
  return generatePath(ROUTES.TODOS_WITH_PARAMS, {
    fileId,
    fileTabId,
  });
}

export function buildAlertsUrl({
  fileId,
  fileTabId,
}: {
  fileId?: string;
  fileTabId?: TABS_FILE;
} = {}): string {
  return generatePath(ROUTES.ALERTS_WITH_PARAMS, {
    fileId,
    fileTabId,
  });
}

export function buildMessagesUrl({
  ticketId,
}: { ticketId?: string } = {}): string {
  return generatePath(ROUTES.MESSAGES, {
    ticketId,
  });
}

export function buildOrdersUrl({ orderId }: { orderId?: string } = {}): string {
  return generatePath(ROUTES.ORDERS, {
    orderId,
  });
}

export function buildTransportUrl({
  transportMenuId,
}: { transportMenuId?: TabsTransport } = {}): string {
  return generatePath(ROUTES.TRANSPORT, {
    transportMenuId,
  });
}

export function buildSparePartUrl({
  sparePartMenuId,
}: { sparePartMenuId?: TABS_SPARE_PARTS } = {}): string {
  return generatePath(ROUTES.SPARE_PARTS, {
    sparePartMenuId,
  });
}
export function buildInterventionReportUrl({
  interventionReportTab,
}: { interventionReportTab?: TABS_INTERVENTION_REPORT } = {}): string {
  return generatePath(ROUTES.INTERVENTION_REPORT, {
    interventionReportTab,
  });
}
export function buildHomeInterventionUrl({
  homeInterventionTab,
}: { homeInterventionTab?: TABS_HOME_INTERVENTION } = {}): string {
  return generatePath(ROUTES.HOME_INTERVENTION, {
    homeInterventionTab,
  });
}
export function buildSparePartRequestLinesUrl({
  requestLineId,
}: { requestLineId?: string } = {}): string {
  return generatePath(SPARE_PART_ROUTES.REQUESTS, {
    requestLineId,
  });
}

export const STOCK_ITEMS_SEARCH_QUERY_PARAM = 'searchQuery';

export function buildStockItemsUrl({
  searchQuery,
}: { searchQuery?: string } = {}): string {
  const path = generatePath(SPARE_PART_ROUTES.STOCK_ITEMS);

  if (!searchQuery) {
    return path;
  }

  const queryString = new URLSearchParams({
    [STOCK_ITEMS_SEARCH_QUERY_PARAM]: searchQuery,
  }).toString();

  return `${path}?${queryString}`;
}
export function buildSasValidationUrl({
  fileReference,
}: { fileReference?: string } = {}): string {
  return generatePath(SPARE_PART_ROUTES.REQUESTS_TO_VALIDATE, {
    fileReference,
  });
}
export function buildBusinessIntelligenceUrl(): string {
  return generatePath(ROUTES.BUSINESS_INTELLIGENCE);
}

export function buildSettingsUrl(): string {
  return generatePath(ROUTES.SETTINGS);
}

interface BuildHistoriesUrl {
  tabId?: TABS_HISTORIES;
  fileUrl?: string;
}

export function buildHistoriesUrl({
  tabId,
  fileUrl,
}: BuildHistoriesUrl): string {
  if (!tabId) {
    return generatePath(`${fileUrl}/${TABS_HISTORIES.FILE}`);
  }

  return generatePath(`${fileUrl}/${tabId}`);
}

export function buildHelpUrl(): string {
  return generatePath(ROUTES.HELP);
}

export function buildBulkChangesUrl(): string {
  return generatePath(ROUTES.BULK_CHANGES);
}

export const buildBillingUrl = ({
  billingTabId,
}: {
  billingTabId?: TABS_BILLING;
}): string => {
  return generatePath(ROUTES.BILLING, {
    billingTabId,
  });
};

export const buildJobsDetailsUrl = ({ jobId }: { jobId?: string }) => {
  return generatePath(ROUTES.JOBS_DETAILS, {
    jobId,
  });
};
